import {
  TextInput,
  NullableBooleanInput,
} from 'react-admin'
import { statusTypeChoices } from '../../shared/orders/util'
import { ActivateAll, DeactivateAll, ArchiveAll, CancelAll } from '../../shared/orders/batch-status-button'
import { Grid } from '@material-ui/core'
import { List, Filter, SelectArrayInput } from '../../custom'
import { useLabel } from '../../../hooks'
import { withCollectionData } from '../../hoc'
import Datagrid from './datagrid'
import CollectionData from '../../shared/orders/collection-data'

const DatagridWithTotals = withCollectionData(Datagrid, CollectionData)

const HourlyOrdersFilter = props => {
  const label = useLabel(props)

  return (
    <Filter>
      <SelectArrayInput
        label={label('status', 'filter')}
        source='status_in'
        choices={statusTypeChoices}
      />
      <NullableBooleanInput label={label('is_created_by_customer')} source='is_created_by_customer_true' />
      <TextInput label={label('order_number', 'filter')} source='order_number_i_cont' />
      <TextInput label={label('hourly_rate', 'filter')} source='hourly_rate_description_i_cont' />
      <TextInput label={label('customer', 'filter')} source='hourly_rate_customer_name_i_cont' />
      <TextInput label={label('location', 'filter')} source='location_name_i_cont' />
      <TextInput label={label('material', 'filter')} source='material_name_i_cont' />
    </Filter>
  )
}

const Actions = () => (
  <>
    <Grid item>
      <ActivateAll />
    </Grid>
    <Grid item>
      <DeactivateAll />
    </Grid>
    <Grid item>
      <CancelAll />
    </Grid>
    <Grid item>
      <ArchiveAll />
    </Grid>
  </>
)

const TonnageOrdersList = props => {
  return (
    <List
      {...props}
      filterDefaultValues={{
        status_in: ['active', 'pending', 'canceled'],
      }}
      filter={{ include_collection_data: true }}
      actions={<Actions />}
      filters={<HourlyOrdersFilter />}
    >
      <DatagridWithTotals />
    </List>
  )
}

export default TonnageOrdersList
